"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisiblePageNumbers = void 0;

var _interfaces = require("./interfaces");

var getVisiblePageNumbers = function getVisiblePageNumbers(_ref) {
  var numberOfPages = _ref.numberOfPages,
      selectedPage = _ref.selectedPage,
      configuration = _ref.configuration,
      variant = _ref.variant;
  var showAllPagesThreshold = configuration.showAllPagesThreshold,
      maxPagesAtEnds = configuration.maxPagesAtEnds,
      maxPagesInCenter = configuration.maxPagesInCenter;

  if (numberOfPages <= showAllPagesThreshold || variant === _interfaces.PaginationVariant.Dotted) {
    var values = [];

    for (var i = 1; i <= numberOfPages; i++) {
      values.push(i);
    }

    return [values];
  }

  var firstSection = [1];

  if (selectedPage < maxPagesAtEnds) {
    for (var _i = 2; _i <= maxPagesAtEnds; _i++) {
      firstSection.push(_i);
    }
  }

  var firstPageOfLastSection = numberOfPages - maxPagesAtEnds + 1; // The middle section displays the selected page with other pages on either side.
  // This number is the number of pages to display on each side, so that the total
  // equals maxPagesInCenter.

  var middlePagesPerSide = (maxPagesInCenter - 1) / 2;
  var middleSection = [];

  if (selectedPage >= maxPagesAtEnds && selectedPage <= firstPageOfLastSection) {
    for (var _i2 = selectedPage - middlePagesPerSide; _i2 < selectedPage; _i2++) {
      middleSection.push(_i2);
    }

    middleSection.push(selectedPage);

    for (var _i3 = selectedPage + 1; _i3 <= selectedPage + middlePagesPerSide; _i3++) {
      middleSection.push(_i3);
    }
  }

  var lastSection = [];

  if (selectedPage > firstPageOfLastSection) {
    for (var _i4 = firstPageOfLastSection; _i4 <= numberOfPages; _i4++) {
      lastSection.push(_i4);
    }
  } else {
    lastSection.push(numberOfPages);
  }

  return [firstSection, middleSection, lastSection].filter(function (section) {
    return section.length > 0;
  });
};

exports.getVisiblePageNumbers = getVisiblePageNumbers;